"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconLoading = function IconLoading(_ref) {
  var className = _ref.className;
  var labelId = (0, _uuid.v4)();
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    role: "img",
    "aria-labelledby": labelId
  }, /*#__PURE__*/_react["default"].createElement("title", {
    id: labelId
  }, "Loading"), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: "1"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000",
    d: "M12 5.25v1.5a5.25 5.25 0 105.246 5.466L17.25 12h1.5a6.75 6.75 0 11-6.987-6.746L12 5.25z"
  })));
};

var _default = IconLoading;
exports["default"] = _default;